export default __webpack_public_path__ + "static/media/2.fab5a24d.gif";